<template>
  <div>
    <table id="table_budgetaire">
      <tr>
        <th class="th_table_budgetaire head title-weight has-background-grid-5" colspan="2">
          <p class="is-size-6 has-text-white has-text-weight-bold"> Budget par période </p>
          <p class="has-text-white is-size-14px"
            v-if="data.dateDebut && data.dateFin">
            {{`Du ${formatDate(data.dateDebut)} au ${formatDate(data.dateFin)}`}}
          </p>
        </th>
      </tr>
      <tr v-for="(column, icol) in columns" :key="icol">
        <th class="th_table_budgetaire has-text-grid-1 is-size-7 has-text-weight-bold has-text-right half_width">
          {{column.title}}
        </th>
        <td :class="`td_table_budgetaire is-size-14px half_width ${column.class}`">
          {{formatNombre(data[column.propriety])}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatNombre, formatDate } from '@/services/general/general';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  props: {
    data: Object,
  },
  computed: {
    ...Recommandation.mapGetters({
      societe: 'societe',
    }),
    columns() {
      let columns = [
        {
          title: 'Budget Brut HT',
          propriety: 'prixBrutNegocie',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Budget Net HT',
          propriety: 'prixNet',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'TLPE',
          propriety: 'tlpe',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Honoraires HT',
          propriety: 'honoraires',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Honoraires frais de traitement HT',
          propriety: 'honoraireFraisTraitement',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Frais Techniques HT',
          propriety: 'fraisTechnique',
          class: 'has-text-right has-text-default',
        },
        {
          title: 'Total',
          propriety: 'prixTotal',
          class: 'has-text-right has-text-weight-bold has-text-grid-1',
        },
      ];
      return columns;
    },
  },
  methods: {
    formatNombre(val) {
      return formatNombre(val);
    },
    formatDate(date) {
      return formatDate(date);
    },
  },
}
</script>

<style>

</style>